import {validFromPartialTable} from '@shared/partials/validfrom-partial.table';
import {meteringPointTypePartial} from '@shared/partials/meteringpointtype-partial.table';
import {meteringPointSubtypePartial} from '@shared/partials/meteringpointsubtype.partial';
import {meterReadingOccurrencePartial} from '@shared/columns/meteringpoint.columns';
import {settlementmethodPartial} from '@shared/partials/settlementmethod.partial';
import {physicalStatusPartial} from '@shared/partials/physicalstatus.partial';
import {StatusCellComponent} from '@shared/components/table/cells/status-cell/status-cell.component';
import {disconnectionTypePartial} from '@shared/partials/disconnectiontype.partial';
import {unitTypePartial} from '@shared/partials/unit-type.partial';
import {productCharacteristicIdentificationPartial} from '@shared/partials/productcharacteristicidentification.partial';
import {meterreadingtypePartial} from '@shared/partials/meterreadingtype.partial';
import {readingcharacteristicsPartial} from '@shared/partials/readingcharacteristics.partial';
import {assettypePartial} from '@shared/partials/assettype.partial';
import {connectiontypePartial} from '@shared/partials/connectiontype.partial';

export const physicalDetailsColumns = [
  {title: 'common.table.index', key: 'index'},
  {
    title: 'meteringpoint.identification',
    key: 'identification',
  },
  validFromPartialTable,
  meteringPointTypePartial,
  physicalStatusPartial,
  meteringPointSubtypePartial,
  connectiontypePartial,
  disconnectionTypePartial,
  {
    title: 'meteringpoint.meterdetails.gridAreaIdentification',
    key: 'gridAreaIdentification',
  },
  {
    title: 'meteringPoint.create.fromArea',
    key: 'fromGridAreaIdentification',
  },
  {
    title: 'meteringPoint.create.toGrid',
    key: 'toGridAreaIdentification',
  },
  {title: 'meteringpoint.table.netSettlementGroup', key: 'netSettlementGroup'},
  {
    title: 'meteringPoint.create.powerPlantIdentification',
    key: 'powerPlantIdentification',
  },
  {
    title: 'meteringpoint.unittype',
    key: 'productCharacteristicUnitType',
  },
  productCharacteristicIdentificationPartial,
  assettypePartial,
  {
    title: 'meteringPoint.create.capacity',
    key: 'capacity',
  },
  {
    title: 'meteringPoint.create.maximumPower',
    key: 'maximumPower',
  },
  {
    title: 'meteringPoint.create.maximumCurrent',
    key: 'maximumCurrent',
  },
  {
    title: 'meteringPoint.create.productionobligation',
    key: 'productionObligation',
  },
  {
    title: 'meteringPoint.create.parentMeteringPointIdentification',
    key: 'parentMeteringPointIdentification',
  },
];

export const locationDetailsColumns = [
  {title: 'common.table.index', key: 'index'},
  {title: 'address.streetCode', key: 'streetCode'},
  {title: 'address.streetName', key: 'streetName'},
  {title: 'address.streetNumber', key: 'buildingNumber'},
  {title: 'address.floor', key: 'floorIdentification'},
  {title: 'address.roomIdentification', key: 'roomIdentification'},
  {title: 'address.zipCode', key: 'postalCode'},
  {title: 'address.city', key: 'cityName'},
  {title: 'address.municipalcode', key: 'municipalityCode'},
  {title: 'address.countrycode', key: 'country'},
  {title: 'meteringpoint.comments', key: 'locationDescription'},
];

export const meteringDetailsColumns = [
  {title: 'common.table.index', key: 'index'},
  settlementmethodPartial,
  meterReadingOccurrencePartial,
  {
    title: 'meteringpoint.meterdetails.estimatedAnnualVolume',
    key: 'estimatedAnnualVolume',
  },
  readingcharacteristicsPartial,
  {title: 'meteringpoint.meterdetails.meterReadingDate01', key: 'meterReadingDate01'},
  {title: 'meteringpoint.meterdetails.meterReadingDate02', key: 'meterReadingDate02'},
  {title: 'meteringpoint.meterdetails.meterReadingDate03', key: 'meterReadingDate03'},
  {title: 'meteringpoint.meterdetails.meterReadingDate04', key: 'meterReadingDate04'},
  {title: 'meteringpoint.meterdetails.meterReadingDate05', key: 'meterReadingDate05'},
  {title: 'meteringpoint.meterdetails.meterReadingDate06', key: 'meterReadingDate06'},
  {title: 'meteringpoint.meterdetails.meterReadingDate07', key: 'meterReadingDate07'},
  {title: 'meteringpoint.meterdetails.meterReadingDate08', key: 'meterReadingDate08'},
  {title: 'meteringpoint.meterdetails.meterReadingDate09', key: 'meterReadingDate09'},
  {title: 'meteringpoint.meterdetails.meterReadingDate10', key: 'meterReadingDate10'},
  {title: 'meteringpoint.meterdetails.meterReadingDate11', key: 'meterReadingDate11'},
  {title: 'meteringpoint.meterdetails.meterReadingDate12', key: 'meterReadingDate12'},
  {
    title: 'meteringpoint.meterdetails.hourlyTimeSeries',
    key: 'hourlyTimeSeries',
    cellRenderer: StatusCellComponent,
    cellRendererParams: {
      0: {color: 'bg-red-500', label: 'common.no'},
      1: {color: 'bg-green-500', label: 'common.yes'},
    }
  },
];

export const meterDetailsColumns = [
  {title: 'common.table.index', key: 'index'},
  {title: 'meter.meterid', key: 'meterIdentification'},
  {title: 'model.numberOfDigits', key: 'numberOfDigits'},
  {title: 'meterFrame.conversionFactor', key: 'conversionFactor'},
  unitTypePartial,
  meterreadingtypePartial,
];
